import { usePaywallCheckoutContext } from "@circle-react/contexts/Paywalls/paywallCheckoutContext";
import { Link } from "@circleco/compass/components/Link";
import { useFormContext } from "react-hook-form";

import { t } from "@/i18n-js/instance";
import { areThereAnyTaxIdsForCountry } from "@/react/utils/paywalls/taxId/helpers";

import { CheckoutFormTaxIdForm } from "./CheckoutFormTaxIdForm";

export const CheckoutFormTaxIdField = () => {
  const { watch } = useFormContext();
  const {
    community_member_billing_info_attributes: {
      address_country: memberAddressCountry,
    },
  } = watch();

  const {
    isMemberAddressRequired,
    isTaxIdCollectionEnabled,
    shouldShowTaxIdForm,
    enableTaxIdCollection,
  } = usePaywallCheckoutContext();

  if (
    !shouldShowTaxIdForm ||
    (isMemberAddressRequired && !memberAddressCountry) ||
    (memberAddressCountry && !areThereAnyTaxIdsForCountry(memberAddressCountry))
  ) {
    return null;
  }

  if (isTaxIdCollectionEnabled) {
    return <CheckoutFormTaxIdForm />;
  }

  return (
    <div className="flex flex-row items-center gap-x-1 underline">
      <Link
        asButton
        size="sm"
        variant="secondary"
        onClick={enableTaxIdCollection}
        data-testid="checkout-form-add-tax-id-button"
      >
        {t("paywall_checkout.form.tax_id.cta")}
      </Link>
    </div>
  );
};
